import { State } from './state';

export class EmbeddedRate {
	state: State;
	rateEBA: number;
	rateNonEBA: number;
}
